// Module
var code = "<button\n  class=\"btn btn-default pull-right margin-right\"\n  ng-click=\"vm.openPreview()\"\n>\n  <i class=\"pe-7s-look fat\"></i>\n</button>\n";
// Exports
module.exports = code;